import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeSetLike, curveGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {curveGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PartitionOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/partition-operator/geometry-partition-operator-node"
import {
    GeometryPartitionOperatorNode,
    partitionOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/partition-operator/geometry-partition-operator-node"

export type CurveGeometryPartitionOperatorParameters = PartitionOperatorParameters<CurveGeometryAttributeLikeNode, CurveGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryPartitionOperatorParameters> = {
    nodeClass: "CurveGeometryPartitionOperator",
    validation: {
        parameters: partitionOperatorParametersSchema(curveGeometryAttributeLike, curveGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryPartitionOperator
    extends GeometryPartitionOperatorNode<1, CurveGeometryAttributeLikeNode, CurveGeometryAttributeSetLikeNode>
    implements CurveGeometryAttributeSetLikeNode
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
